var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useMemo } from 'react';
import { DEVICE_TYPE } from '@tving/utils/src/constants/commonConstants';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
import { useFocusable } from '@tving/utils/src/utils/tving-focusable';
import StyledSquareButtonLayer from './SquareButtonLayer.style';
/**
 * ButtonItemComponent wrapping 하는 layer
 * 네비게이션 처리 및 버튼 액션 처리를 위한 로직을 담당.
 */
var SquareButtonLayer = function (_a) {
    var text = _a.text, icon = _a.icon, focusedIcon = _a.focusedIcon, handleSelect = _a.handleSelect, style = _a.style, focusStyle = _a.focusStyle, focusKey = _a.focusKey, className = _a.className, handleFocus = _a.handleFocus, parentFocus = _a.parentFocus;
    var _b = useFocusable({
        onEnterPress: handleSelect,
        onFocus: handleFocus,
        focusKey: focusKey,
    }), ref = _b.ref, focused = _b.focused, focusSelf = _b.focusSelf;
    var isFocused = useMemo(function () {
        if (parentFocus !== undefined) {
            return parentFocus;
        }
        return focused;
    }, [parentFocus, focused]);
    var handleMouseOver = function () {
        var deviceType = getDeviceType();
        if (deviceType === DEVICE_TYPE.WEB || deviceType === DEVICE_TYPE.WEBOS) {
            focusSelf();
        }
    };
    return (_jsxs(StyledSquareButtonLayer, __assign({ tabIndex: -1, className: "".concat(isFocused ? 'focused' : '', "  ").concat(className || ''), ref: ref, onClick: function (e) {
            e.stopPropagation();
            if (handleSelect) {
                handleSelect();
            }
        }, style: isFocused ? focusStyle : style, onMouseOver: handleMouseOver }, { children: [text, icon && !isFocused && _jsx("img", { tabIndex: -1, src: icon, alt: "icon" }), focusedIcon && isFocused && _jsx("img", { tabIndex: -1, src: focusedIcon, alt: "icon" })] })));
};
export default SquareButtonLayer;
